// Placeholder — will be implemented in M3
console.log('mux setup — coming soon');
